import styled from "styled-components";
import React from "react";


const Row = styled.tr`
  border-bottom: 1px solid var(--color-table-border);
`;

const Cell = styled.td`
  padding: 10px;
  font-size: 14px;
  color: var(--color-text-body);
  overflow-wrap: anywhere;
`;


const renderTableCell = (cell) => {
    return <Cell {...cell.getCellProps()} className={cell.column.id}>{cell.render("Cell")}</Cell>;
};

const renderTableRow = (row, prepareRow) => {
    prepareRow(row);
    return (
        <Row {...row.getRowProps()}>
            {row.cells.map((cell) => renderTableCell(cell))}
        </Row>
    );
};

const TableBody = ({tableInstance}) => {
    const {getTableBodyProps, page, prepareRow} = tableInstance;

    return (
        <tbody {...getTableBodyProps()}>
        {page.map((row) => renderTableRow(row, prepareRow))}
        </tbody>
    );
};

export default TableBody;